import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TokenCacheService } from '../services/token-cache.service';
import { resolveRequestToken } from '../utils/request-token.util';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenCache = inject(TokenCacheService);
  const router = inject(Router);

  if (req.url.includes('/api/kiosk/') && !req.headers.has('Authorization')) {
    const kioskToken = resolveKioskToken();
    if (kioskToken) {
      return next(req.clone({ setHeaders: { Authorization: `Bearer ${kioskToken}` } }));
    }
  }

  const token = resolveRequestToken(router.url, tokenCache);

  if (token && !req.headers.has('Authorization')) {
    return next(req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    }));
  }

  return next(req);
};

function resolveKioskToken(): string | null {
  const raw = localStorage.getItem('pidepaya_kiosk_session');
  if (!raw) return null;
  try {
    const session = JSON.parse(raw);
    return session?.token ?? null;
  } catch {
    return null;
  }
}
